/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Role admin list, editor, analysis, and copy modal.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {AdminResourcePagesModule} from '../../common/controller/admin-resource-pages.module';
import {RoleEditPageComponent} from './role-edit-page.component';
import {RoleCopyModalComponent} from './role-copy-modal.component';
import {RoleItemPageComponent} from './role-item-page.component';
import {RoleListPageComponent} from './role-list-page.component';
import {RoleAnalysisPageComponent} from './role-analysis-page.component';
import {RoleRoutePageComponent} from './role-route-page.component';

const ROLE = [
  RoleEditPageComponent,
  RoleCopyModalComponent,
  RoleItemPageComponent,
  RoleListPageComponent,
  RoleAnalysisPageComponent,
  RoleRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    AdminResourcePagesModule
  ],
  declarations: ROLE,
  exports: ROLE
})
export class RoleModule {
}
